/* eslint-disable max-len */
/* 
Stress / Pressure / Fatigue
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 

Distraction / Complacency / Lack of awareness
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},

Lack of communication / teamwork / assertiveness
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},

Lack of resources, lack of knowledge, norms
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
*/


/*
Lack of Communication 
{type: 'dirtyDozen', dirtyDozenId: 1, value: 1},

Distraction 
{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},

Lack of Resources 
{type: 'dirtyDozen', dirtyDozenId: 3, value: 1},

Stress 
{type: 'dirtyDozen', dirtyDozenId: 4, value: 1},

Complacency 
{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},

Lack of Teamwork 
{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},

Pressure 
{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},

Lack of Awareness 
{type: 'dirtyDozen', dirtyDozenId: 8, value: 1},

Lack of Knowledge 
{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},

Fatigue 
{type: 'dirtyDozen', dirtyDozenId: 10, value: 1},

Lack of Assertiveness 
{type: 'dirtyDozen', dirtyDozenId: 11, value: 1},

Norms 
{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},

*/

/*
{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
*/

let eventCardsData = {
	/* Day 1 */
	'day-1': [
		{
			id: 5,
			title: {
				en: 'Counting stock',
				de: 'Lagerbestand zählen',
				pt: 'Contando stock'
			},
			text: {
				en: 'The maintenance workshop is not very busy at the time. You are asked to assist the spares department in a counting of stock. How do you react?',
				de: 'In der Werkstatt herrscht zur Zeit nicht viel Betrieb. Sie werden gebeten, im Ersatzteillager bei der Zählung der Bestände zu helfen. Wie reagieren Sie?',
				pt: 'A oficina de manutenção não está muito movimentada no momento. Você é solicitado a auxiliar o departamento de peças de reposição na contagem do stock. Como você reage?'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Refuse. This is work not suitable for a person of your skill level.',
						de: 'Sie lehnen ab. Diese Arbeit ist für eine Person mit Ihren Fähigkeiten nicht geeignet.',
						pt: 'Recuse. Este trabalho não é adequado para alguém com o seu nível de habilidade.'
					},
					consequences: {
						text: {
							en: 'Teamwork is suffering here.',
							de: 'Die Teamarbeit leidet darunter.',
							pt: 'O trabalho em equipe está a Ser afetado'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You accept since the pay is the same as you normally get.',
						de: 'Sie nehmen die Arbeit an, da die Bezahlung derjenigen entspricht, die Sie normalerweise erhalten.',
						pt: 'Você aceita, já que o pagamento é o mesmo que você recebe normalmente.'
					},
					consequences: {
						text: {
							en: 'Accepting the job can strengthen the sense of teamwork',
							de: 'Wenn Sie die Arbeit annehmen, kann das den Teamgeist stärken.',
							pt: 'Aceitar o trabalho pode fortalecer o espírito de equipe.'
						},
						effects: [
							{type: 'time', value: 1},	
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You do not want to do this type of work. To avoid it you report ill.',
						de: 'Sie wollen diese Art von Arbeit nicht machen. Um sie zu vermeiden, melden Sie sich krank.',
						pt: 'Você não quer fazer esse tipo de trabalho. Para evitá-lo, você alega estar doente.'
					},
					consequences: {
						text: {
							en: 'Not all job are equally interesting - Norms can challenge the teamwork',
							de: 'Nicht alle Jobs sind gleich interessant - Persönliche Standards können die Teamarbeit herausfordern.',
							pt: 'Nem todos os trabalhos são igualmente interessantes - as normas podem desafiar o trabalho em equipe.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
			]
		},
		{
			id: 6,
			title: {
				en: 'The neighbor company',
				de: 'Das Nachbarunternehmen',
				pt: 'A empresa vizinha'
			},
			text: {
				en: 'The neighbor company is short on manpower. Your company has sold them your assistance for the next 5 weeks. You soon discover that their safety and quality standards are much lower than what you are used to. How do you react?',
				de: 'Das Nachbarunternehmen hat einen Mangel an Arbeitskräften. Ihr Unternehmen hat Sie als Hilfe für die nächsten 5 Wochen ausgeliehen. Schon bald stellen Sie fest, dass die Sicherheits- und Qualitätsstandards des Betriebs viel niedriger sind als die, die Sie gewohnt sind. Wie reagieren Sie darauf?',
				pt: 'A empresa vizinha está com falta de pessoal. Sua empresa vendeu seus serviços para eles para as próximas 5 semanas. Quando lá chega, você descobre que os padrões de segurança e qualidade deles são muito inferiores aos que você está acostumado. Como você reage?'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'This is not your business to address. You do your own tasks to the standards, you are used to.',
						de: 'Es ist nicht Ihre Aufgabe, sich darum zu kümmern. Sie erledigen Ihre eigenen Aufgaben nach den Standards, an die Sie gewöhnt sind.',
						pt: 'Isso não é da sua conta. Você realiza suas tarefas de acordo com os padrões aos quais está acostumado.'
					},
					consequences: {
						text: {
							en: 'Being assertive and true to the good fundamentals of work is essential.',
							de: 'Es ist wichtig, dass Sie sich durchsetzen und den guten Grundsätzen der Arbeit treu bleiben.',
							pt: 'Ser assertivo e fiel aos bons princípios do trabalho é essencial.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You are not supposed to release any of the work, so you do not care about which standard is applied.',
						de: 'Sie sollen nichts von der Arbeit freigeben, also ist es Ihnen egal, welcher Standard angewendet wird.',
						pt: 'Você não deve divulgar nenhuma parte do trabalho, portanto não se importa com qual padrão será aplicado.'
					},
					consequences: {
						text: {
							en: 'Lack of assertiveness may cause substandard work and errors to take place',
							de: 'Mangel an Durchsetzungskraft könnte zu minderwertiger Ausführung der Arbeit und Fehlern führen.',
							pt: 'A falta de assertividade pode levar a trabalhos de qualidade inferior e à ocorrência de erros.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You tell your own company, that you do not want to compromise your standards, and ask them to assign another person to work for the neighbor company.',
						de: 'Sie sagen Ihrem eigenen Unternehmen, dass Sie Ihre Standards nicht verringern wollen, und bitten es, eine andere Person für die Arbeit im Nachbarunternehmen einzusetzen.',
						pt: 'Você informa à sua própria empresa que não deseja comprometer seus padrões e pede que designem outra pessoa para trabalhar na empresa vizinha.'
					},
					consequences: {
						text: {
							en: 'Starting a dialog about safety is generally a good thing. Remember to communicate about it in a professional manner.',
							de: 'Die Anregung eines Gesprächs über Sicherheit ist im Allgemeinen eine gute Sache. Denken Sie aber daran, auf professionelle Art und Weise darüber zu sprechen.',
							pt: 'Iniciar um diálogo sobre segurança geralmente é uma boa ideia. Lembre-se de comunicar o assunto de maneira profissional.'
						},
						effects: [
							{type: 'cost', value: 2},
							{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]}, 
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 7,
			title: {
				en: 'Out of stock',
				de: 'Nicht auf Lager',
				pt: 'Fora de estoque'
			},
			text: {
				en: 'There is an AOG. You need a special consumable, which is out of stock. The normal and approved vendor cannot deliver until next day. Another, but not approved, vendor can however deliver here-and-now. What do you do?',
				de: 'Es gibt ein AOG. Sie benötigen ein spezielles Verbrauchsmaterial, das nicht auf Lager ist. Der bisher genutzte und zugelassene Lieferant kann erst am nächsten Tag liefern. Ein anderer, bisher nicht zugelassener Lieferant, kann jedoch heute noch liefern. Was tun Sie nun?',
				pt: 'Há uma aeronave no solo (AOG). Você precisa de um consumível especial, que está em falta. O fornecedor normal e autorizado só pode entregar amanhã. Outro fornecedor, porém não autorizado, pode entregar imediatamente. O que você faz?'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Postpone the work until the approved source can deliver.',
						de: 'Sie verschieben die Arbeit, bis der zugelassene Lieferant liefern kann.',
						pt: 'Adiar o trabalho até que a fonte aprovada possa entregar.'
					},
					consequences: {
						text: {
							en: 'Hopefully company Norms will support your actions',
							de: 'Hoffentlich werden die Unternehmensrichtlinien Ihr Vorgehen unterstützen.',
							pt: 'Esperamos que as normas da empresa apoiem suas ações.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 3, value: 1},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'Use the unapproved vendor here and now, file a safety report about your actions, and takes steps to ensure that the vendor gets approved for use in the future.',
						de: 'Verwenden Sie den nicht zugelassenen Anbieter hier und jetzt, erstellen Sie einen Sicherheitsbericht über Ihr Vorgehen und unternehmen Sie Schritte, um sicherzustellen, dass der Anbieter für die Zukunft zugelassen wird.',
						pt: 'Utilize o fornecedor não autorizado neste momento, apresente um relatório de segurança sobre suas ações e tome as medidas necessárias para garantir que o fornecedor seja aprovado para uso no futuro.'
					},
					consequences: {
						text: {
							en: 'Reporting this may help develop more robust procedures taking similar situations into account.',
							de: 'Die Berichterstattung darüber kann zur Entwicklung robusterer Verfahren beitragen, die ähnliche Situationen berücksichtigen.',
							pt: 'Relatar isso pode ajudar a desenvolver procedimentos mais robustos, levando em consideração situações semelhantes.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},

						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'Break this stupid rule. Obtain the consumable from the unapproved vendor without using the formal system, so that no records exists of the transaction.',
						de: 'Brechen sie diese dumme Regel. Beziehen Sie das Verbrauchsmaterial von dem nicht zugelassenen Lieferanten, ohne das formale System zu nutzen, so dass keine Aufzeichnungen über die Transaktion existieren.',
						pt: 'Quebre essa regra estúpida. Obtenha o material de consumo do fornecedor não autorizado sem usar o sistema formal, de modo que não haja registro da transação.'
					},
					consequences: {
						text: {
							en: 'Within Safety Management it is essential that work as perceived equals work as performed. Management may think there is never any problems.',
							de: 'Im Rahmen des Sicherheitsmanagements ist es wichtig, dass die wahrgenommene Arbeit der geleisteten Arbeit entspricht. Das Management könnte ansonsten denken, dass es nie zu Zwischenfällen kommt.',
							pt: 'Na Gestão de Segurança, é essencial que o trabalho, conforme percebido, seja igual ao trabalho executado. Os supervisores podem achar que nunca há problemas.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 8,
			title: {
				en: 'Access to manuals',
				de: 'Zugang zu Handbüchern',
				pt: 'Acesso a manuais'
			},
			text: {
				en: 'The company keeps all manuals available on a manual server. In one of the hangars the network connection is however so slow and unstable, that it is practically impossible to access any manuals. What do you do?',
				de: 'Das Unternehmen hält alle Handbücher auf einem Handbuchserver bereit. In einem der Hangars ist die Netzwerkverbindung jedoch so langsam und instabil, dass es praktisch unmöglich ist, auf die Handbücher zuzugreifen. Was können Sie tun?',
				pt: 'A empresa mantém todos os manuais disponíveis num servidor. Em um dos hangares, porém, a conexão de rede é tão lenta e instável que é praticamente impossível aceder a qualquer manual. O que você faz?'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Copy the most frequently used manuals from the server onto the local computer, so they are easy to access and open.',
						de: 'Sie kopieren die am häufigsten verwendeten Handbücher vom Server auf den lokalen Computer, damit sie leicht zugänglich sind und geöffnet werden können.',
						pt: 'Copie os manuais mais utilizados do servidor para o computador local, para que sejam fáceis de aceder e abrir.'
					},
					consequences: {
						text: {
							en: 'If no procedure is available to keep the copies updated, you may end up using invalid information',
							de: 'Wenn es kein Verfahren gibt, um die Kopien auf dem neuesten Stand zu halten, kann es passieren, dass Sie veraltete Informationen verwenden.',
							pt: 'Se não houver um procedimento disponível para manter as cópias atualizadas, você poderá acabar usando informações inválidas.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'Go to the other hangars and extract hard copies of the information you need.',
						de: 'Sie gehen in einen anderen Hangar und holen die benötigten Informationen in Papierform.',
						pt: 'Vá até os outros hangares e pegue cópias impressas das informações que você precisa.'
					},
					consequences: {
						text: {
							en: 'This could work if you remember that the copies are now uncontrolled documents.',
							de: 'Dies könnte funktionieren, wenn Sie daran denken, dass die Kopien evtl. nicht mehr auf dem neuesten Stand sind.',
							pt: 'Isso poderia funcionar se você se lembrar de que as cópias agora são documentos não controlados.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'For now you work from memory if the system is down, but you file a safety report, so steps can be taken to resolve the issue.',
						de: 'Sie arbeiten erst einmal nach Gedächtnis, wenn das System ausgefallen ist. Sie reichen aber einen Sicherheitsbericht ein, damit Schritte zur Behebung des Problems eingeleitet werden können.',
						pt: 'Por enquanto, você trabalha de memória se o sistema estiver inativo, mas registra um relatório de segurança para que medidas possam ser tomadas para resolver o problema.'
					},
					consequences: {
						text: {
							en: 'Pointing out this problem to management is good, but working from memory can create errors.',
							de: 'Es ist gut, die Unternehmensleitung auf dieses Problem hinzuweisen, aber die Arbeit aus dem Gedächtnis kann zu Fehlern führen.',
							pt: 'Apontar esse problema para a gestão é bom, mas trabalhar de memória pode gerar erros.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
			]
		}
	],
	/* Day 2 */
	'day-2': [
		{
			id: 10,
			title: {
				en: 'Stress',
				de: 'Stress',
				pt: 'Stress'
			},
			text: {
				en: 'You have noticed that a colleague shows signs of stress. How do you react?',
				de: 'Sie haben festgestellt, dass ein Kollege Anzeichen von Stress zeigt. Wie reagieren Sie darauf?',
				pt: 'Você percebeu que um colega está demonstrando sinais de stress. Como você reage?'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Ask him how he is doing and offer to help him seek advice or help, if needed.',
						de: 'Sie fragen ihn, wie es ihm geht, und bieten Sie ihm an, ihm bei der Suche nach Rat oder Hilfe zu helfen, falls nötig.',
						pt: 'Pergunte-lhe como ele está e ofereça-se para ajudá-lo a procurar conselhos ou ajuda, se necessário.'
					},
					consequences: {
						text: {
							en: 'An assertive action. Be aware that the way you communicate can cause him to reject your help.',
							de: 'Eine selbstbewusste Maßnahme. Seien Sie sich bewusst, dass die Art und Weise, wie Sie kommunizieren, dazu führen kann, dass er Ihre Hilfe ablehnt.',
							pt: 'Uma atitude assertiva. Esteja ciente de que a forma como você se comunica pode fazer com que ele rejeite sua ajuda.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'Do nothing - this is a personal thing which you should not involve yourself in.',
						de: 'Sie tun nichts - dies ist eine persönliche Angelegenheit, in die Sie sich nicht einmischen sollten.',
						pt: 'Não faça nada - isso é algo pessoal no qual você não deve se envolver.'
					},
					consequences: {
						text: {
							en: 'Often signs of stress are more visible to others that one self. Look out for each other in the team.',
							de: 'Oft sind die Anzeichen von Stress für andere besser sichtbar als für einen selbst. Achten Sie im Team aufeinander.',
							pt: 'Muitas vezes, os sinais de stress são mais visíveis para os outros do que para a própria pessoa. Cuidem uns dos outros na equipa.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 1, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'HR should deal with this - you leave them an anonymous note about your observations.',
						de: 'Die Personalabteilung sollte sich damit befassen - Sie hinterlassen ihr eine anonyme Notiz über Ihre Beobachtungen.',
						pt: 'O departamento de RH deve lidar com isso - você pode deixar um bilhete anônimo relatando suas observações.'
					},
					consequences: {
						text: {
							en: 'Being contacted by HR can cause rejection. Company Norms play a big role here.',
							de: 'Wenn Sie von der Personalabteilung kontaktiert werden, kann das zu Ablehnung führen. Die betrieblichen Werte spielen hier eine große Rolle.',
							pt: 'Ser contatado pelo RH pode resultar em rejeição. As normas da empresa desempenham um papel importante nesse processo.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},	
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 11,
			title: {
				en: 'Note to pilots',
				de: 'Hinweis für Piloten',
				pt: 'Nota aos pilotos'
			},
			text: {
				en: 'As a new person in the company, you notice that the technicians quite often release a job without doing an operational test after replacing e.g. lamps or antennas. They instead leave a note to pilots about checking the system before flight. What is your reaction to this?',
				de: 'Als neuer Mitarbeiter im Unternehmen stellen Sie fest, dass die Techniker häufig einen Auftrag freigeben, ohne nach dem Austausch von z. B. Lampen oder Antennen einen Betriebstest durchzuführen. Stattdessen hinterlassen sie einen Hinweis an die Piloten, dass sie das System vor dem Flug überprüfen sollen. Was ist Ihre Reaktion darauf?',
				pt: 'Como recém-chegado à empresa, você percebe que os técnicos frequentemente libertam um serviço sem realizar um teste operacional após a substituição de peças como lâmpadas ou antenas. Em vez disso, eles deixam um aviso para os pilotos sobre a necessidade de verificar o sistema antes do voo. Qual a sua reação a isso?'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Seems like a timesaving and good idea. The pilots have to verify that their systems are GO before flight anyway.',
						de: 'Es scheint eine zeitsparende und gute Idee zu sein. Die Piloten müssen sich vor dem Flug ohnehin vergewissern, dass ihre Systeme in Ordnung sind.',
						pt: 'Parece uma boa ideia e que economiza tempo. De qualquer forma, os pilotos precisam verificar se seus sistemas estão funcionando corretamente antes do voo.'
					},
					consequences: {
						text: {
							en: 'An Operational Check is part of a good error capture system. Never sign for anything you did not do.',
							de: 'Ein Operational Check ist Teil eines guten Fehlererfassungssystems. Unterschreiben Sie nie für etwas, das Sie nicht getan haben.',
							pt: 'Uma verificação operacional faz parte de um bom sistema de detecção de erros. Nunca assine nada que você não tenha feito.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'This is the company norm - you accept that and have no personal opinion about it.',
						de: 'Dies ist die Vorgehensweise im Unternehmen - Sie akzeptieren das und haben keine eigene Meinung dazu.',
						pt: 'Essa é a norma da empresa - você aceita isso e não tem opinião pessoal a respeito.'
					},
					consequences: {
						text: {
							en: 'Norms may be good or bad. What is important is that the work is carried out to the applicable Standard.',
							de: 'Vorgehensweisen können gut oder schlecht sein. Wichtig ist, dass die Arbeit nach geltenden Normen ausgeführt wird.',
							pt: 'As normas podem ser boas ou más. O importante é que o trabalho seja executado de acordo com a norma aplicável.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'This is unacceptable and you file a safety report with some examples.',
						de: 'Dies ist inakzeptabel und Sie reichen einen Sicherheitsbericht mit einigen Beispielen ein.',
						pt: 'Isso é inaceitável e você deve apresentar um relatório de segurança com alguns exemplos.'
					},
					consequences: {
						text: {
							en: 'Norms are difficult to change. Involvement of Safety Management may put focus on this problem.',
							de: 'Normen sind schwer zu ändern. Die Einbindung des Sicherheitsmanagements kann dieses Problem in den Mittelpunkt rücken.',
							pt: 'As normas são difíceis de mudar. O envolvimento da Gestão de Segurança pode dar foco a esse problema.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 12,
			title: {
				en: 'An audit',
				de: 'Ein Audit',
				pt: 'Uma auditoria'
			},
			text: {
				en: 'There is a compliance audit of the work shop going on today, and one of the auditors has informed you, that he will be observing how you perform a task. How do you react?',
				de: 'Heute findet ein Compliance-Audit in der Werkstatt statt, und einer der Auditoren hat Ihnen mitgeteilt, dass er Sie bei der Ausführung einer Aufgabe beobachten wird. Wie reagieren Sie darauf?',
				pt: 'Está a decorrer hoje uma auditoria de conformidade na oficina, e um dos auditores informou-o de que irá observar a forma como executa uma tarefa. Como reage?'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'This is a good chance to show how well both you and the workshop adhere to quality and safety standards.',
						de: 'Dies ist eine gute Gelegenheit zu zeigen, wie gut Sie und die Werkstatt die Qualitäts- und Sicherheitsstandards einhalten.',
						pt: 'Esta é uma boa oportunidade para demonstrar o quão bem você e a oficina seguem os padrões de qualidade e segurança.'
					},
					consequences: {
						text: {
							en: 'Audits are important for maintaining approvals and keeping management informed about what is happening.',
							de: 'Audits sind wichtig, um Genehmigungen aufrechtzuerhalten und das Management über den Stand der Dinge zu informieren.',
							pt: 'As auditorias são importantes para manter as aprovações e manter a gestão informada sobre o que está acontecendo.'
						},
						effects: [
							{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You are very annoyed about this interference, which you consider a major distraction. You have no intention about making this easy for the auditor.',
						de: 'Sie sind sehr verärgert über diese Störung, die Sie als eine große Ablenkung empfinden. Sie haben nicht die Absicht, es dem Auditor leicht zu machen.',
						pt: 'Você está muito incomodado com essa interferência, que considera uma grande distração. Você não tem nenhuma intenção de facilitar o trabalho do auditor.'
					},
					consequences: {
						text: {
							en: 'Some distractions are unavoidable. The AM expects staff to cooperate with auditors.',
							de: 'Einige Ablenkungen sind unvermeidlich. Der Accountable Manager erwartet, dass das Personal mit Auditoren kooperiert.',
							pt: 'Algumas distrações são inevitáveis. O gestor de auditorias espera que os funcionários cooperem com os auditores.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You do not want this kind of attention to your work. You tell the supervisor that he must persuade the auditor to find another to look at.',
						de: 'Sie möchten diese Art von Aufmerksamkeit nicht auf Ihre Arbeit gerichtet haben. Sie sagen dem Vorgesetzten, dass er den Auditor überzeugen muss, einen anderen Mitarbeiter zu auditieren.',
						pt: 'Você não quer esse tipo de atenção voltada para o seu trabalho. Você diz ao supervisor que ele deve convencer o auditor a encontrar outra pessoa para analisar o caso.'
					},
					consequences: {
						text: {
							en: 'Auditors are a part of the team. How you perform indicates how well standards are implemented.',
							de: 'Auditoren sind ein Teil des Teams. Deine Leistung zeigt, wie gut die Standards bei euch umgesetzt werden.',
							pt: 'Os auditores fazem parte da equipe. Seu desempenho indica a eficácia da implementação das normas.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 13,
			title: {
				en: 'A final check',
				de: 'Eine abschließende Kontrolle',
				pt: 'Uma verificação final'
			},
			text: {
				en: 'All jobs are completed after inspections and you ask a colleague to close all the access panels. You notice that he does so without looking for foreign objects prior to closing the panels. What is your reaction?',
				de: 'Alle Arbeiten sind nach der Inspektion abgeschlossen und Sie bitten einen Kollegen, alle Zugangsdeckel zu schließen. Sie stellen fest, dass er dies tut, ohne vor dem Schließen der Öffnungen nach Fremdkörpern zu suchen. Was ist Ihre Reaktion?',
				pt: 'Após a conclusão de todas as tarefas e inspeções, você pede a um colega que feche todos os painéis de acesso. Você percebe que ele faz isso sem verificar a presença de objetos estranhos antes de fechar os painéis. Qual é a sua reação?'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'It should not be necessary to do any additional checks, since all the task cards state the jobs are completed (except for the panel closing).',
						de: 'Es sollte nicht notwendig sein, zusätzliche Kontrollen durchzuführen, da auf allen Arbeitskarten vermerkt ist, dass die Arbeiten abgeschlossen sind (mit Ausnahme des Schließens der Deckel).',
						pt: 'Não deve ser necessário realizar nenhuma verificação adicional, visto que todos os cartões de tarefas indicam que os trabalhos foram concluídos (exceto o fecho de paineis).'
					},
					consequences: {
						text: {
							en: 'A final visual check is an important element of good error capturing practices.',
							de: 'Eine abschließende Sichtprüfung ist ein wichtiges Element einer guten Vorgehensweise bei der Fehlererfassung.',
							pt: 'Uma verificação visual final é um elemento importante das boas práticas de registro de erros.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You stop the job, insist that the closed panels are reopened and that visual inspections are performed prior to closing any panels.',
						de: 'Sie stoppen die Arbeiten, bestehen darauf, dass die geschlossenen Panels wieder geöffnet werden und dass vor dem Schließen aller Panels eine Sichtprüfung durchgeführt wird.',
						pt: 'Você interrompe o trabalho, insiste que os painéis fechados sejam reabertos e que inspeções visuais sejam realizadas antes do fechamento de qualquer painel.'
					},
					consequences: {
						text: {
							en: 'Being assertive and true to the good fundamentals of error capturing is essential.',
							de: 'Es ist wichtig, dass Sie sich durchsetzen und den guten Grundsätzen der Fehlererfassung treu bleiben.',
							pt: 'Ser assertivo e fiel aos bons princípios da identificação de erros é essencial.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You consider any extra visual check optional. It is a good idea if time and manpower permits this to be done, but it is not absolutely necessary to do.',
						de: 'Sie betrachten jede zusätzliche Sichtprüfung als optional. Es ist eine gute Idee, wenn die Zeit und die Arbeitskraft dies erlauben, aber es ist nicht unbedingt notwendig.',
						pt: 'Você considera qualquer verificação visual adicional como opcional. É uma boa ideia realizá-la se houver tempo e pessoal disponíveis, mas não é absolutamente necessário.'
					},
					consequences: {
						text: {
							en: 'Standards and norms should not be subject to variation depending on the situation.',
							de: 'Standards und Normen sollten nicht je nach Situation variiert werden.',
							pt: 'Padrões e normas não devem estar sujeitos a variações dependendo da situação.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		}
	],
	/* Day 3 */
	'day-3': [
		{
			id: 20,
			title: {
				en: 'The training session',
				de: 'Die Trainingsveranstaltung',
				pt: 'A sessão de treino'
			},
			text: {
				en: 'The entire department has been asked to participate in some specialised training sessions being held on site. You have had similar training before at your old work place. So what do you do?',
				de: 'Die gesamte Abteilung wurde gebeten, an einer speziellen Schulung teilzunehmen, die vor Ort stattfindet. Sie haben eine ähnliche Schulung bereits an Ihrem alten Arbeitsplatz absolviert. Was tun Sie also?',
				pt: 'Todo o departamento foi solicitado a participar de algumas sessões de treino especializado que serão realizadas no local. Você já participou de treinos semelhantes no seu antigo emprego. Então, o que você faz?'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You do not participate in this training which you do not consider necessary for you. You do however take you chance to put your name on the participation list so you are not called in again later.',
						de: 'Sie nehmen nicht an dieser Schulung teil, die Sie nicht für notwendig erachten. Sie nutzen jedoch die Gelegenheit, sich in die Teilnehmerliste einzutragen, damit Sie später nicht noch einmal einbestellt werden.',
						pt: 'Você não participa neste treino, que não considera necessário. No entanto, aproveita a oportunidade para inscrever seu nome na lista de participantes e evitar ser chamado novamente mais tarde.'
					},
					consequences: {
						text: {
							en: 'This training may be different and it would be complacent to skip the opportunity to refresh your knowledge.',
							de: 'Diese Schulung könnte anders sein, und es wäre selbstgefällig, die Gelegenheit zur Auffrischung Ihrer Kenntnisse auszulassen.',
							pt: 'Este treino pode ser diferente e seria negligente perder a oportunidade de atualizar seus conhecimentos.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]}, 
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
					
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You participate in the training.',
						de: 'Sie nehmen an der Schulung teil.',
						pt: 'Você participa do treino.'
					},
					consequences: {
						text: {
							en: 'Knowing this subject may provide you an opportunity to give valuable inputs during the training.',
							de: 'Wenn Sie das Thema kennen, können Sie während der Schulung wertvolle Beiträge leisten.',
							pt: 'Conhecer este assunto pode lhe proporcionar a oportunidade de contribuir com informações valiosas durante o treinamento.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {	
						en: 'You ask the training manager to credit you for previous training.',
						de: 'Sie bitten den Schulungsleiter, Ihnen die frühere Schulung anzurechnen.',
						pt: 'Você solicita á direção de formação que lhe seja creditado o treino anterior.'
					},
					consequences: {
						text: {
							en: 'A review of you previous training may show that you are in compliance with requirements.',
							de: 'Eine Überprüfung Ihrer bisherigen Ausbildung kann zeigen, dass Sie die Anforderungen erfüllen.',
							pt: 'Uma análise da sua formação anterior poderá demonstrar que você cumpre os requisitos.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 21,
			title: {
				en: 'In the drain',
				de: 'Im Abfluss',
				pt: 'No ralo'
			},
			text: {
				en: 'You notice that a colleague pours used solvent in the sewer drain. What do you do?',
				de: 'Sie bemerken, dass ein Kollege benutztes Lösungsmittel in den Abfluss schüttet. Was tun Sie?',
				pt: 'Você percebe que um colega está despejando solvente usado no ralo do esgoto. O que você faz?'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Nothing.',
						de: 'Nichts.',
						pt: 'Nada'
					},
					consequences: {
						text: {
							en: 'Lack of assertiveness and failure to address obvious violations may cause damage to both the environment and the company reputation.',
							de: 'Fehlendes Engagement und das Versäumnis, offensichtliche Verstöße anzusprechen, können sowohl der Umwelt als auch dem Ruf des Unternehmens schaden.',
							pt: 'A falta de assertividade e a negligência em lidar com violações óbvias podem causar danos tanto ao meio ambiente quanto à reputação da empresa.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 11, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},	
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
				
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'Confront him and asks him not to do it again because of the environmental impact.',
						de: 'Sie konfrontieren ihn damit und bitten ihn, dies wegen der Umweltauswirkungen nicht mehr zu tun.',
						pt: 'Confronte-o e peça-lhe que não o faça novamente devido ao impacto ambiental.'
					},
					consequences: {
						text: {
							en: 'A assertive interaction can be fine if communicated in the right way.',
							de: 'Eine durchsetzungsfähige Interaktion kann in Ordnung sein, wenn sie auf die richtige Weise kommuniziert wird.',
							pt: 'Uma interação assertiva pode ser positiva se comunicada da maneira correta.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You do not confront your colleague but file a report about it.',
						de: 'Sie konfrontieren Ihren Kollegen nicht damit, sondern erstellen einen Sicherheitsbericht darüber.',
						pt: 'Você não confronta seu colega, mas registra uma queixa sobre o ocorrido.'
					},
					consequences: {
						text: {
							en: 'Keeping safety managers informed about such things may help put focus on an area where improvements is needed.',
							de: 'Wenn Sie den Safety Manager über solche Dinge auf dem Laufenden halten, kann dies dazu beitragen, den Schwerpunkt auf einen Bereich zu legen, in dem Verbesserungen erforderlich sind.',
							pt: 'Manter os gestores de segurança informados sobre esses assuntos pode ajudar a direcionar o foco para áreas que necessitam de melhorias.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
			]
		},
		{
			id: 22,
			title: {
				en: 'The electrician',
				de: 'Der Elektriker',
				pt: 'O eletricista'
			},
			text: {
				en: 'An outside electrician is brought in to work on the parking hangar lighting system. He is going to work very close to several of the parked aircrafts.',
				de: 'Ein externer Elektriker wird beauftragt, an der Beleuchtung der Abstellhalle zu arbeiten. Er wird in unmittelbarer Nähe zu mehreren geparkten Flugzeugen arbeiten.',
				pt: 'Um eletricista externo é contratado para trabalhar no sistema de iluminação do hangar de estacionamento. Ele trabalhará muito próximo a várias aeronaves estacionadas.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You ask him to stop work until the hangar has been emptied.',
						de: 'Sie bitten ihn, die Arbeiten einzustellen, bis der Hangar geräumt ist.',
						pt: 'Você pede-lhe que interrompa o trabalho até que o hangar esteja vazio.'
					},
					consequences: {
						text: {
							en: `Although time-consuming this will effectively limit the aircraft's exposure to damage.`,
							de: 'Dies ist zwar zeitaufwändig, aber die Gefahr, dass die Flugzeuge beschädigt werden, wird dadurch wirksam begrenzt.',
							pt: `Embora demorado, isso limitará efetivamente a exposição da aeronave a danos.`
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You ask him to be very careful and let you know if he damages anything.',
						de: 'Sie bitten ihn, sehr vorsichtig zu sein und Ihnen Bescheid zu geben, wenn er etwas beschädigt.',
						pt: 'Você pede-lhe que tenha muito cuidado e que avise caso danifique alguma coisa.'
					},
					consequences: {
						text: {
							en: 'A person without proper training and knowledge may not himself be aware when a damage has occurred.',
							de: 'Eine Person, die nicht entsprechend geschult ist, merkt möglicherweise selbst nicht, wenn ein Schaden entstanden ist.',
							pt: 'Uma pessoa sem a formação e o conhecimento adequados pode não perceber quando um dano ocorreu.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You remain in the area in order to monitor his work.',
						de: 'Sie bleiben in der Nähe, um seine Arbeit zu überwachen.',
						pt: 'Você permanece na área para monitorar o trabalho dele.'
					},
					consequences: {
						text: {
							en: 'Supervision and monitoring may not prevent any damage but could aid in its detection.',
							de: 'Beaufsichtigung und Überwachung können Schäden zwar nicht verhindern, aber sie können helfen, sie zu erkennen.',
							pt: 'A supervisão e o monitoramento podem não impedir completamente os danos, mas podem auxiliar na sua detecção.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 10, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
			]
		},
		{
			id: 23,
			title: {
				en: 'Distraction',
				de: 'Ablenkung',
				pt: 'Distração'
			},
			text: {
				en: 'Female cabin crew attendants often pass through the hangar area. You notice that some of your male colleagues gets distracted by this. What is your reaction?',
				de: 'Weibliche Flugbegleiterinnen gehen oft durch den Hangarbereich. Sie bemerken, dass sich einige Ihrer männlichen Kollegen dadurch ablenken lassen. Wie reagieren Sie darauf?',
				pt: 'As comissárias de bordo costumam passar pela área do hangar. Você percebe que alguns de seus colegas homens se distraem com isso. Qual é a sua reação?'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You contact the crews and ask them do stay out of the hangar.',
						de: 'Sie wenden sich an die Besatzungen und bitten sie, den Hangar nicht zu betreten.',
						pt: 'Você entra em contato com as equipes e pede que elas fiquem fora do hangar.'
					},
					consequences: {
						text: {
							en: 'Removing the distraction is a good option if the communication is done right.',
							de: 'Die Ablenkung zu vermeiden ist eine gute Option, sofern die Kommunikation richtig verläuft.',
							pt: 'Eliminar a distração é uma boa opção se a comunicação for feita corretamente.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 8, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You ask your colleagues to act professionally.',
						de: 'Sie bitten Ihre Kollegen, sich professionell zu verhalten.',
						pt: 'Você pede aos seus colegas que ajam profissionalmente.'
					},
					consequences: {
						text: {
							en: 'Your colleagues may feel accused and teamwork may suffer if the communication is not done properly',
							de: 'Ihre Kollegen könnten sich beschuldigt fühlen und die Teamarbeit könnte darunter leiden, wenn die entsprechende Kommunikation nicht richtig stattfindet.',
							pt: 'Seus colegas podem se sentir acusados ​​e o trabalho em equipe pode ser prejudicado se a comunicação não for feita adequadamente.'
						},
						effects: [
							{type: 'risk', value: 1},	
							{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},

							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You file an anonymous report about your observations.',
						de: 'Sie reichen einen anonymen Bericht über Ihre Beobachtungen ein.',
						pt: 'Você envia um relatório anônimo sobre suas observações.'
					},
					consequences: {
						text: {
							en: 'It may be a good idea to leave sensitive issues to the safety department to investigate.',
							de: 'Es kann eine gute Idee sein, die Untersuchung sensibler Fragen der Sicherheitsabteilung zu überlassen.',
							pt: 'Pode ser uma boa ideia deixar que questões delicadas sejam investigadas pelo departamento de segurança.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
			]
		}
	],
	/* Day 4 */
	'day-4': [
		{
			id: 25,
			title: {
				en: 'Double shifts',
				de: 'Doppelschichten',
				pt: 'Turnos duplos'
			},
			text: {
				en: 'Management has together with the union representative introduced double hours shifts for the next 5 weeks due to production increase. All staff is positive about this but also concerned about fatigue issues.',
				de: 'Die Geschäftsleitung hat zusammen mit dem Gewerkschaftsvertreter aufgrund der Produktionssteigerung für die nächsten 5 Wochen Doppelschichten eingeführt. Das gesamte Personal ist darüber erfreut, aber auch besorgt über Ermüdungserscheinungen.',
				pt: 'A gestão, em conjunto com o representante sindical, implementou turnos de trabalho dobrados pelas próximas 5 semanas devido ao aumento da produção. Todos os funcionários receberam a medida com satisfação, mas também estão preocupados com a possibilidade de fadiga.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Request a solution from management which takes human factors into account.',
						de: 'Sie verlangen von der Unternehmensleitung eine Lösung, die die Human Factors berücksichtigt.',
						pt: 'Solicite à gestão uma solução que leve em consideração os fatores humanos.'
					},
					consequences: {
						text: {
							en: 'This should be part of the Risk assessment during the management change process. Lack of assertiveness from staff and/or lack of Human Factors training for management may however prevent this from being addressed.',
							de: 'Dies sollte Teil der Risikobewertung während des "Management of Change" Prozesses sein. Fehlendes Selbstbewusstsein des Personals und/oder Schulung des Managements in Bezug auf Human Factors können verhindern, dass dieses Thema berücksichtigt wird.',
							pt: 'Isso deve fazer parte da avaliação de riscos durante o processo de mudança gerencial. A falta de assertividade por parte da equipe e/ou a falta de formação em fatores humanos para a gestão podem, no entanto, impedir que essa questão seja abordada.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},

							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
			
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'This is not worth meddling with. Keep a low profile and look after yourself.',
						de: 'Hier lohnt es sich nicht, sich einzumischen. Sie halten sich unauffällig und kümmern sich um sich selbst.',
						pt: 'Não vale a pena se meter nisso. Mantenha um perfil discreto e cuide de si mesmo.'
					},
					consequences: {
						text: {
							en: 'Lack of assertiveness leaves latent problems unsolved. Risk of making errors increase with fatigue, if mitigating measures are not introduced.',
							de: 'Mangelndes Durchsetzungsvermögen lässt latente Probleme ungelöst. Das Risiko, Fehler zu machen, steigt mit zunehmender Ermüdung, wenn keine Abhilfemaßnahmen getroffen werden.',
							pt: 'A falta de assertividade deixa problemas latentes sem solução. O risco de cometer erros aumenta com a fadiga, caso medidas atenuantes não sejam implementadas.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 10, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You just do the best you can. This is a management decision so Human Factor principles must yield.',
						de: 'Sie tun einfach Ihr Bestes. Das ist eine Managemententscheidung, also müssen die Grundsätze des Human Factors hinten angestellt werden.',
						pt: 'Você simplesmente faz o melhor que pode. Esta é uma decisão da gestão, portanto, os princípios de Fatores Humanos devem ser levados em consideração.'
					},
					consequences: {
						text: {
							en: 'Human Factor principles should be applied at all levels of the organisation. Especially latent problems may go unsolved if management is not actively involved.',
							de: 'Die Grundsätze der Human Factors sollten auf allen Ebenen der Organisation angewandt werden. Insbesondere latente Probleme können ungelöst bleiben, wenn das Management nicht aktiv einbezogen wird.',
							pt: 'Os princípios do fator humano devem ser aplicados em todos os níveis da organização. Problemas latentes, em particular, podem permanecer sem solução se a gestão não estiver ativamente envolvida.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},	
						],
					},
				},
			]
		},
		{
			id: 26,
			title: {
				en: 'Personal safety',
				de: 'Persönliche Sicherheit',
				pt: 'Segurança pessoal'
			},
			text: {
				en: 'You notice that upper management often ignore the requirements for use of protective safety equipment when entering the work areas.',
				de: 'Sie stellen fest, dass die obere Führungsebene die Anforderungen an das Tragen von Schutzausrüstungen beim Betreten der Arbeitsbereiche häufig ignoriert.',
				pt: 'Você percebe que a alta administração frequentemente ignora os requisitos para o uso de equipamentos de proteção individual ao entrar nas áreas de trabalho.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'It is OK. Management sets the standards, so they can break them too, if they want.',
						de: 'Das ist in Ordnung. Die Geschäftsleitung legt die Normen fest, also kann sie auch gegen sie verstoßen, wenn sie will.',
						pt: 'Não tem problema. A gerência define os padrões, então eles também podem quebrá-los, se quiserem.'
					},
					consequences: {
						text: {
							en: 'In a company with a sound safety culture the standards should apply to all.',
							de: 'In einem Unternehmen mit einer soliden Sicherheitskultur gelten die Normen für alle Mitarbeiter gleichermaßen.',
							pt: 'Em uma empresa com uma cultura de segurança sólida, as normas devem ser aplicadas a todos.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You point it out to them next time you see it happen.',
						de: 'Sie weisen sie das nächste Mal darauf hin, wenn Sie so etwas sehen.',
						pt: 'Na próxima vez que isso acontecer, mostre a eles.'
					},
					consequences: {
						text: {
							en: 'Very assertive but the method of communication may be cause for rejection.',
							de: 'Das ist sehr wirkungsvoll, aber die Art der Kommunikation kann zu Ablehnung führen.',
							pt: 'Muito assertivo, mas o método de comunicação pode ser motivo de rejeição.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You file an anonymous safety report about it.',
						de: 'Sie erstatten einen anonymen Sicherheitsbericht über den Vorfall.',
						pt: 'Você registra um relatório de segurança anônimo sobre isso.'
					},
					consequences: {
						text: {
							en: 'The safety department should be able to handle this type of problem',
							de: 'Die Sicherheitsabteilung sollte in der Lage sein, mit dieser Art von Problem umzugehen.',
							pt: 'O departamento de segurança deve ser capaz de lidar com esse tipo de problema.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'time', value: 1},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 27,
			title: {
				en: 'Personal phone calls',
				de: 'Persönliche Telefongespräche',
				pt: 'Chamadas pessoais'
			},
			text: {
				en: 'Against company safety policy, a member of your team tends to spend a lot of time on personal phone calls. How do you react?',
				de: 'Entgegen den Sicherheitsrichtlinien des Unternehmens neigt ein Mitglied Ihres Teams dazu, viel Zeit mit privaten Telefonaten zu verbringen. Wie reagieren Sie darauf?',
				pt: 'Contrariando as normas de segurança da empresa, um membro da sua equipa tende a passar muito tempo em ligações telefônicas pessoais. Como você reage?'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You do nothing about this.',
						de: 'Sie unternehmen nichts dagegen.',
						pt: 'Você não faz nada a respeito.'
					},
					consequences: {
						text: {
							en: 'Neglecting problems may cause them to become triggers of safety incidents.',
							de: 'Die Vernachlässigung von Problemen kann dazu führen, dass diese zu Auslösern von Sicherheitsvorfällen werden.',
							pt: 'Negligenciar problemas pode fazer com que eles se tornem gatilhos para incidentes de segurança.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
					
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You kindly inform him about the dangers of distractions and insist that he changes his behavior.',
						de: 'Sie weisen ihn freundlich auf die Gefahren von Ablenkungen hin und bestehen darauf, dass er sein Verhalten ändert.',
						pt: 'Gentilmente, você o informa sobre os perigos das distrações e insiste para que ele mude seu comportamento.'
					},
					consequences: {
						text: {
							en: 'Making good norms clear in an assertive manner can be good if proper communication is used.',
							de: 'Gute Standards überzeugend darzustellen kann helfen, wenn sie angemessen kommuniziert werden.',
							pt: 'Deixar as boas normas claras de forma assertiva pode ser benéfico se houver comunicação adequada.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You do not confront him but file an anonymous report about your observations.',
						de: 'Sie konfrontieren ihn nicht, sondern erstatten einen anonymen Bericht über Ihre Beobachtungen.',
						pt: 'Você não o confronta, mas registra uma denúncia anônima sobre suas observações.'
					},
					consequences: {
						text: {
							en: 'The safety department should be able to handle this type of problem',
							de: 'Die Sicherheitsabteilung sollte in der Lage sein, mit dieser Art von Problem umzugehen.',
							pt: 'O departamento de segurança deve ser capaz de lidar com esse tipo de problema.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
			]
		},
		{
			id: 28,
			title: {
				en: 'The cover-up',
				de: 'Die Vertuschung',
				pt: 'O encobrimento'
			},
			text: {
				en: 'Before an audit, the supervisor asks you to help cover-up the fact, that previous findings has not been properly addressed.',
				de: 'Vor einem Audit bittet der Vorgesetzte Sie, die Tatsache zu vertuschen, dass frühere Beanstandungen nicht vernünftig abgestellt wurden.',
				pt: 'Antes de uma auditoria, o supervisor pede que você ajude a encobrir o fato de que as constatações anteriores não foram devidamente tratadas.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'This is fine. The workshop should be allowed to address this in due time without outside interference.',
						de: 'Das ist in Ordnung. Die Werkstatt sollte die Möglichkeit haben, dies zu gegebener Zeit ohne Einmischung von außen zu klären.',
						pt: 'Está tudo bem. O workshop deve ter a oportunidade de abordar este assunto em tempo oportuno, sem interferência externa.'
					},
					consequences: {
						text: {
							en: `Deceiving an auditor is deceiving the Accountable Manager. Safety is in everybody's interest and norms should reflect this.`,
							de: 'Einen Auditor zu täuschen bedeutet, den Accountable Manager zu täuschen. Sicherheit liegt im Interesse aller, und die Normen sollten dies widerspiegeln.',
							pt: `Enganar um auditor é enganar o gestor responsável. A segurança interessa a todos e as normas devem refletir isso.`
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},	
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You tell your supervisor that you will not support his cover-up.',
						de: 'Sie sagen Ihrem Vorgesetzten, dass Sie seine Vertuschung nicht unterstützen werden.',
						pt: 'Você diz ao seu supervisor que não vai apoiar a tentativa dele de encobrir o ocorrido.'
					},
					consequences: {
						text: {
							en: 'Assertive action but future teamwork may suffer if proper communication is not used.',
							de: 'Dies ist ein mutiger Schritt, aber die zukünftige Zusammenarbeit im Team könnte darunter leiden, wenn keine angemessene Kommunikation stattfindet.',
							pt: 'Ação assertiva é importante, mas o trabalho em equipe futuro pode ser prejudicado se a comunicação adequada não for utilizada.'
						},
						effects: [
							{type: 'dirtyDozen', dirtyDozenId: 1, value: 1},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You do not challenge this but take sick leave on the day.',
						de: 'Sie stellen dies nicht in Frage, sondern lassen sich an dem Tag krankschreiben.',
						pt: 'Você não contesta isso, mas tira uma licença médica no mesmo dia.'
					},
					consequences: {
						text: {
							en: 'This does not solve the underlying problems with workshop norms.',
							de: 'Auf diese Weise werden die zugrundeliegenden Probleme, die mit den Werkstattnormen verbunden sind, nicht gelöst.',
							pt: 'Isso não resolve os problemas subjacentes às normas de workshop.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
			]
		}
	]
};


export { eventCardsData };
